import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import AddBanners from "../AddBanners";
import { fetchAllBanners } from "../reducer/bannerSlice";
import { reset } from "../reducer/bannerSlice";

const InitMiddlewareAddBanners: React.FC<any> = (props) => {
  const { isLoading, isSuccess, addBanners, deleteBanner, updateBanners } = useSelector(
    (state: any) => state.rootReducer?.banner
  );
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = [
      {
        label: "Banners",
        link: `/banners`,
      },
    ];
    store.dispatch(addBreadcrumb(data));
    store.dispatch(fetchAllBanners(null));
  }, []);

  useEffect(() => {
    if (isSuccess && (addBanners?.success === true || deleteBanner?.success === true || updateBanners?.success === true)) {
      store.dispatch(fetchAllBanners(null));
      store.dispatch(reset());
    }
  }, [isSuccess, addBanners, deleteBanner, updateBanners]);
  return <AddBanners {...props} />;
};

export default InitMiddlewareAddBanners;
